import { createFileRoute } from "@tanstack/react-router";
import { CommandsView } from "@/modules/chat/components/CommandsView";

export const Route = createFileRoute("/_app/commands")({
  component: CommandsView,
});
